export const AgentStatusOptions = [
  { label: "On Call", value: "On Call" },
  { label: "Available", value: "Available" },
  { label: "On Break", value: "On Break" },
  { label: "Logged Out", value: "Logged Out" },
  { label: "Wrap Up", value: "Wrap Up" },
];

export const DeviceOptions = [
  { label: "Phone", value: "False" },
  { label: "Softphone", value: "True" },
];

export const CustomerStatusOptions = [
  { label: "On Call", value: "On Call" },
  { label: "On Hold", value: "On Hold" },
];
